// ##############################
// // // ExtendedForms view styles
// #############################

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const extendedFormsStyle = {
  ...customCheckboxRadioSwitch,
  ...customSelectStyle,
  ...cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  label: {
    cursor: "pointer",
    paddingLeft: "0",
    color: "rgba(0, 0, 0, 0.26)",
    fontSize: "14px",
    lineHeight: "1.428571429",
    fontWeight: "400",
    display: "inline-flex"
  },
  responsiveHorizontalScroll: {
    display: 'flex',
    overflowX: 'auto',
    justifyContent: 'space-between',
    "@media (min-width: 600px)": {
      overflowX: 'initial',
    }
  },
  loteActionsAnimation: {
    transition: "all .3s ease"
  },
  hideFilters: {
    opacity: 0,
    maxHeight: 0,
    overflow: 'hidden'
  },
  showFilters: {
    opacity: 1,
    maxHeight: 300
  },
  filterSelect: {
    padding: '8px 10px'
  },
  radarSearchField: {
    marginBottom: 0,
    paddingTop: 30
  }
};

export default extendedFormsStyle;
